import { render, staticRenderFns } from "./DataTableServerPagination.vue?vue&type=template&id=792f7a30"
import script from "./DataTableServerPagination.vue?vue&type=script&lang=js"
export * from "./DataTableServerPagination.vue?vue&type=script&lang=js"
import style0 from "./DataTableServerPagination.vue?vue&type=style&index=0&id=792f7a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports